/**
 * A chat API response that was not ok, carrying its HTTP status so callers
 * can act on it (a 404 means the chat expired, chat#274) instead of parsing
 * the message.
 */
export class ChatApiError extends Error {
  readonly status: number

  constructor(status: number, message: string) {
    super(message)
    this.name = 'ChatApiError'
    this.status = status
  }
}

/** Throws a `ChatApiError` for a response that was not ok. */
export function throwIfNotOk(res: Response, label: string): void {
  if (!res.ok) {
    throw new ChatApiError(res.status, `${label}: ${res.status}`)
  }
}
